// Shared tenant-branding logo lookup - single source of truth for "which logo represents the
// current WellSpring tenant", reused by OneColumnLayoutComponent's own emr-sidebar (patient/
// doctor/reviewer sessions) and by the standalone Care Navigator shell (which has no nb-menu of
// its own for that sidebar to populate, so it renders this same branding directly - see
// one-column.layout.ts's isCareNavigatorSession).
export function getTenantLogoSrc(): string {
  const custLogo = localStorage.getItem('customerTenantLogo');
  return localStorage.getItem('tenantType') === 'secondopinion'
    ? 'assets/images/caresphere/so-logo.svg'
    : custLogo ?? 'assets/images/ezovion-logo.png';
}

export function getTenantLogoAlt(): string {
  return localStorage.getItem('tenantType') === 'secondopinion'
    ? 'Second Opinion Logo'
    : 'Care Sphere Logo';
}

// The Second Opinion logo's own artwork (icon + wordmark + tagline) is wider relative to its
// height than the plain Care Sphere logo, so it needs a touch more width to stay legible.
export function getTenantLogoWidth(): string {
  return localStorage.getItem('tenantType') === 'secondopinion' ? '140px' : '130px';
}
